import React from 'react';
import { View, StyleSheet, Dimensions } from 'react-native';

const { height } = Dimensions.get('window');

const styles = StyleSheet.create({
  child: {
    justifyContent: 'center',
  },
});

interface Props {
  width?: number;
  children?: React.ReactNode;
}

const SwipedView: React.FC<Props> = ({ width, children }) => {
  const viewSize = React.useRef<{ width: number; height: number }>({
    width,
    height,
  });
  return (
    <View
      style={[styles.child, { width }]}
      onLayout={(event) => {
        const { width, height } = event.nativeEvent.layout;
        viewSize.current = { width, height };
        console.log('child View', viewSize.current);
      }}
    >
      {children}
    </View>
  );
};

export default SwipedView;
